// Import necessary modules from Firebase SDK
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Initialize Firebase
const config = {
  apiKey: "AIzaSyDU8LquL8LEHACl6zOZPCl6qhvRgKpZ0-M",
  authDomain: "posible-app-prod.firebaseapp.com",
  databaseURL: "https://posible-app-prod.firebaseio.com",
  projectId: "posible-app-prod",
  storageBucket: "posible.in",
  appId: '1:1057547901573:android:567360a4165b2f2a',
};

// Initialize Firebase app
const app = initializeApp(config);

// Initialize Firebase services
export const database = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);  // Changed from storageRef to storage
export const functions = getFunctions(app);
export const storageRef = getStorage(app);

// Export storage functions
export { ref, uploadBytes, getDownloadURL, deleteObject };

export default app;